/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseImportOldMessageResult } from '../../models/api-response-import-old-message-result';
import { ImportOldMessageRequest } from '../../models/import-old-message-request';

export interface ImportOldMessages$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: ImportOldMessageRequest
}

export function importOldMessages(http: HttpClient, rootUrl: string, params: ImportOldMessages$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseImportOldMessageResult>> {
  const rb = new RequestBuilder(rootUrl, importOldMessages.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseImportOldMessageResult>;
    })
  );
}

importOldMessages.PATH = '/v1/api/ui/conversation/import-old-messages';
